import React, { useCallback } from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Modal, TextArea, TextInputSuffix } from 'Components/atoms'
import Button from '@material-ui/core/Button'
import colors from 'Assets/colors'

import {
  useStyles,
  ExtraServiceDesc,
  ExtraServicePH,
  ExtraServiceTitle,
  BoxContainer,
  ExtraServiceImportant,
} from './styled'

const ModalAddExtraService = ({
  showExtraServiceModal,
  setShowExtraServiceModal,
  extraServiceDesc,
  setExtraServiceDesc,
  extraServicePrice,
  setExtraServicePrice,
  onUpdateExtraServiceInfo,
  isEdit,
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const onChange = useCallback(
    e => {
      setExtraServiceDesc(e.target.value)
      setExtraServicePrice(extraServicePrice)
      e.stopPropagation()
    },
    [extraServicePrice, setExtraServiceDesc, setExtraServicePrice]
  )

  const onChangePrice = useCallback(
    e => {
      const text = e.target.value?.replace('.', ',')
      if (!text) {
        setExtraServicePrice('')
        setExtraServiceDesc(extraServiceDesc)
        return
      }

      if (text.length === 0) {
        setExtraServicePrice('')
        setExtraServiceDesc(extraServiceDesc)
        return
      }

      if (/^[0-9,]$/.test(text[text.length - 1])) {
        const splitText = text.split(',')
        if (splitText.length - 1 > 1) {
          const newValue = splitText.reduce((acc, item) => acc.concat(item), '')
          setExtraServicePrice(newValue)
          setExtraServiceDesc(extraServiceDesc)

          e.stopPropagation()
          return
        }
        setExtraServicePrice(text)
        setExtraServiceDesc(extraServiceDesc)
      }

      e.stopPropagation()
    },
    [extraServiceDesc, setExtraServiceDesc, setExtraServicePrice]
  )

  const notValue = !extraServiceDesc || !extraServicePrice || extraServiceDesc === '' || extraServicePrice === ''
  const eSPrice = extraServicePrice ? extraServicePrice?.replace(',', '.') : 0
  const valueToNumber = parseFloat(eSPrice) || 0
  const exceedsMaxLength = extraServiceDesc && extraServiceDesc.length > 500
  const isDisabled = notValue || valueToNumber === 0 || exceedsMaxLength
  return (
    <Modal
      isOpen={showExtraServiceModal}
      height='600px'
      width='850px'
      setIsOpen={setShowExtraServiceModal}
      onClose={() => setShowExtraServiceModal(false)}
      borderRadius='8px'
      bottomBackground='semitransparent'
    >
      <BoxContainer>
        <ExtraServiceDesc>{t('descExtra')}</ExtraServiceDesc>
        <ExtraServicePH>{t('extraInfo')}</ExtraServicePH>
        <ExtraServiceTitle>{t('extraProducts')}</ExtraServiceTitle>

        <TextArea
          placeholder={t('extraProductsPHolder')}
          multiple
          value={extraServiceDesc}
          onChange={onChange}
          padding='0.5rem 1rem'
          background='#F4F1F1'
          marginBottom='10px'
          rows={5}
          maxLength={500}
          errorMaxLengthMessage={t('extraProductsErrorMaxLengthMessage')}
        />

        <ExtraServiceTitle>{t('extraPrice')}</ExtraServiceTitle>

        <TextInputSuffix
          placeholder={t('extraPricePHolder')}
          value={extraServicePrice}
          onChange={onChangePrice}
          padding='20px'
          background='#F4F1F1'
          suffix='€'
        />
        <ExtraServiceImportant>
          <strong>Importante:</strong> {t('extraServiceImportant').replace('Importante: ', '')}
        </ExtraServiceImportant>
        <Button
          className={classes.addButton}
          onClick={onUpdateExtraServiceInfo}
          disabled={isDisabled}
          variant='contained'
          color={colors.white}
          backgroundColor={isDisabled ? colors.gray3 : colors.secondary}
          borderColor={isDisabled ? colors.gray3 : colors.secondary}
        >
          {isEdit ? t('saveExtra') : t('addExtra')}
        </Button>
      </BoxContainer>
    </Modal>
  )
}

ModalAddExtraService.defaultProps = {
  showExtraServiceModal: false,
  setShowExtraServiceModal: () => {},
  extraServiceDesc: null,
  setExtraServiceDesc: () => {},
  extraServicePrice: null,
  setExtraServicePrice: () => {},
  onUpdateExtraServiceInfo: () => {},
  isEdit: false,
}

ModalAddExtraService.propTypes = {
  showExtraServiceModal: PropTypes.bool,
  setShowExtraServiceModal: PropTypes.func,
  extraServiceDesc: PropTypes.string || null,
  setExtraServiceDesc: PropTypes.func,
  extraServicePrice: PropTypes.string || null,
  setExtraServicePrice: PropTypes.func,
  onUpdateExtraServiceInfo: PropTypes.func,
  isEdit: PropTypes.bool,
}

export default ModalAddExtraService
